/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ant-reset-private/blob/master/LICENSE
 */

export default {
  // Options.jsx
  items_per_page: '/ strani',
  jump_to: 'Idi na',
  page: '',

  // Pagination.jsx
  prev_page: 'Prethodna strana',
  next_page: 'SledeÄa strana',
  prev_5: 'Prethodnih 5 Strana',
  next_5: 'SledeÄih 5 Strana',
  prev_3: 'Prethodnih 3 Strane',
  next_3: 'SledeÄih 3 Strane'
};
